export default (router, store, cookie, logger = console, to) => {
  return new Promise((resolve, reject) => {
    // router.onReady(() => {
    const matchedComponents = router.getMatchedComponents(to)
    if (!matchedComponents || !matchedComponents.length) {
      return reject({
        code: '404'
      })
    }
    Promise.all(
      matchedComponents.map(component => {
        logger.info('----- preFetch inside -----\n')
        let prefetch = Promise.resolve()
        if (component.preFetch) {
          if (component.dataStore) {
            let storeList = []
            if (
              Object.prototype.toString.call(component.dataStore) ===
              '[object Array]'
            ) {
              storeList = [...component.dataStore]
            } else {
              storeList = [component.dataStore]
            }

            storeList.forEach(ds => {
              const { name, store: _store } = ds
              logger.info('----- preFetch storeList -----\n')

              if (!store.state[name]) {
                console.log('inject store', name)
                store.registerModule(name, _store)
              }
            })
          }
          prefetch = component
            .preFetch(
              {
                store,
                cookie,
                route: to ? to : router.currentRoute
              },
              logger
            )
            .then(() => {
              logger.info('----- preFetch return -----\n')
              // logger.info(res)
              // if (component.meta) {
              //   store.replaceState({
              //     ...store.state,
              //     meta: component.meta({store})
              //   })
              // }
              return Promise.resolve()
            })
            .catch(e => {
              logger.error('----- preFetch error -----', e)
              return Promise.reject(e)
            })
        }
        return prefetch
      })
    )
      .then(resolve)
      .catch(e => reject(e))
    // })
  })
}
